import { createFileRoute } from "@tanstack/react-router";
import { OG_IMAGE, absolute, hreflangLinks } from "@/lib/site";
import { breadcrumbList } from "@/lib/schema";
import { InsightsIndex } from "@/components/insights/InsightsIndex";

const TITLE = "ISO Certification Guides & Insights | IraqCert";
const DESC =
  "Direct answers on ISO certification cost, process, accreditation, and oil & gas standards in Iraq and the Gulf. Practical guides from IraqCert.";

export const Route = createFileRoute("/insights/")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: absolute("/insights") },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: absolute("/insights") }, ...hreflangLinks("/insights")],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          breadcrumbList([
            { name: "Home", path: "/" },
            { name: "Insights", path: "/insights" },
          ]),
        ),
      },
    ],
  }),
  component: InsightsIndex,
});
